import { defineStyleConfig } from '@chakra-ui/react';

export const Modal = defineStyleConfig({
  baseStyle: {
    dialog: {
      bg: 'surface.card',
      borderRadius: '2xl',
    },
    overlay: {
      bg: 'surface.overlay',
    },
  },
});
